module.exports = __webpack_public_path__ + "media/img/vca/nomh1-0520d2a142a229ad1730f429e649e672.png";